var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editFlag)?_c('Register',{attrs:{"parent":_vm.$data}}):(_vm.completedFlag)?_c('Completion',{attrs:{"parent":_vm.$data}}):_c('Comfirm',{attrs:{"parent":_vm.$data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }